import React, { createContext, useContext, useEffect, useState } from 'react';
import { TranslationService } from '../translation-service';

type TranslationServiceContextType = typeof TranslationService & {
  ready: boolean;
};

const TranslationContext = createContext<TranslationServiceContextType>({
  ...TranslationService,
  ready: false,
});

export const TranslationServiceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const initialize = async (): Promise<void> => {
      try {
        await TranslationService.initLocales();
      } catch (err) {
        console.error('TranslationService init failed:', err);
      } finally {
        if (isMounted) {
          setReady(true);
        }
      }
    };

    initialize().catch((err) => {
      console.error('Unhandled TranslationService init error:', err);
    });

    TranslationService.onReady((): void => {
      if (isMounted) {
        setReady(true);
      }
    });

    return (): void => {
      isMounted = false;
    };
  }, []);

  return (
    <TranslationContext.Provider value={{ ...TranslationService, ready }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslationService = (): TranslationServiceContextType =>
  useContext(TranslationContext);
